<template>
  <div class="villa-preview" :class="this.lang">
    <a :href="'/'+this.lang+'/villas/'+villa.url" class="image">
      <div class="img-loader"></div>
      <img v-if="!lazyImages" :src="villa.photos[0].high" :alt="villa.title">
      <bg-image v-else :src="villa.photos[0].high" :placeholder="villa.photos[0].low"></bg-image>
    </a>

    <div class="details">
      <p class="carousel-position">{{position + 1}}/{{length}}</p>

      <a :href="'/'+this.lang+'/villas/'+villa.url" class="title">{{villa.title}}</a>

      <p class="descr mb-sm-5 mb-3">{{villa.descr}}</p>

      <ul class="specs mb-sm-5 mb-3">
        <li class="spec">
          <img src="/site/idealesresort/dist/images/bed.svg" alt="bed" />
          <p>{{villa.bedrooms}}</p>
        </li>

        <li class="spec">
          <img src="/site/idealesresort/dist/images/bath.svg" alt="bath" />
          <p>{{villa.bathrooms}}</p>
        </li>
      </ul>

      <ul class="info-buttons">
        <li>
          <a :href="'/'+this.lang+'/villas/'+villa.url" class="btn-primary">{{trans.photos[this.lang]}}</a>
        </li>
        <li>
          <a :href="'/'+this.lang+'/villas/'+villa.url+'?section=pricing'" class="btn-primary">{{trans.pricing[this.lang]}}</a>
        </li>
        <li>
          <a :href="'/'+this.lang+'/villas/'+villa.url+'?section=features'" class="btn-primary">{{trans.features[this.lang]}}</a>
        </li>
        <li>
          <a :href="'/'+this.lang+'/villas/'+villa.url+'?section=info'" class="btn-primary">{{trans.info[this.lang]}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      villa: {
        type: Object,
        required: true,
        default: null,
      },
      length: {
        type: Number,
        required: false,
        default: 0,
      },
      position: {
        type: Number,
        required: false,
        default: 0,
      },
      lazyImages: {
        type: Boolean,
        required: false,
        default: true,
      },
      lang: {
        type: String,
        default: window.Laravel.code
      }
    },
    data() {
      return {
        trans: {
          photos: {
            en: 'PHOTOS',
            el: 'ΦΩΤΟΓΡΑΦΙΕΣ',
            it: 'FOTO',
            fr: 'PHOTOS',
          },
          pricing: {
            en: 'PRICING',
            el: 'ΤΙΜΕΣ',
            it: 'PREZZI',
            fr: 'PRIX',
          },
          features: {
            en: 'FEATURES',
            el: 'ΠΑΡΟΧΕΣ',
            it: 'VANTAGGI',
            fr: 'AVANTAGES',
          },
          info: {
            en: 'INFO',
            el: 'ΠΛΗΡΟΦΟΡΙΕΣ',
            it: 'INFO',
            fr: 'INFO',
          },
        }
      }
    }
  };
</script>

<style lang="scss">
  @import 'src/sass/variables';
  @import 'src/sass/mixins';
  @import 'node_modules/bootstrap/scss/vendor/rfs';

  .villa-preview {

    .image {
      display: block;
      padding-top: 66%;
      position: relative;

      .bg-image-component {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
      }
    }

    .details {
      background: $white;
      padding: 45px 27px;
      position: relative;

      .carousel-position {
        @include font-size(0.6875rem);
        color: $secondary;
        position: absolute;
        top: 10px;
        right: 10px;
      }

      .title {
        @include font-size(2.3rem);
        font-weight: $font-weight-bold;
        font-family: $font-family-serif;
        line-height: 1;
        margin-bottom: 5px;
      }

      .descr {
        @include font-size(0.9375rem);
        font-weight: $font-weight-medium;
        color: $gray;
      }

      .specs {
        @include li-separator(80, $medium);
        display: inline-flex;
        align-items: center;

        .spec {
          display: inline-flex;
          align-items: center;
          padding-top: 15px;
          padding-bottom: 15px;

          img {
            margin-right: 26px;
          }

          p {
            @include font-size(1.5rem);
            font-weight: $font-weight-bold;
            font-family: $font-family-serif;
          }

          &:nth-child(1) {
            img {
              height: 27px;
            }
          }

          &:nth-child(2) {
            img {
              height: 35px;
            }
          }
        }
      }

      .info-buttons {
        @include ul-nostyle;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-left: -4px;
        margin-right: -4px;

        li {
          margin: 2px;
        }
      }
    }

    &.el {
      .details {
        padding: 45px 15px;

        .info-buttons {
          .btn-primary {
            padding: 15px 8px;
          }
        }
      }
    }
  }

  // SM
  @media only screen and (max-width: 575px) {
    .villa-preview {
      .details {
        padding: 34px 13px 13px 13px;

        .descr {
          min-height: 42px;
          margin-bottom: 10px;
        }

        .specs {
          li {
            margin-left: 30px;
            padding-left: 30px;
          }

          .spec {

            &:nth-child(1) {
              img {
                height: 20px;
              }
            }

            &:nth-child(2) {
              img {
                height: 27px;
              }
            }
          }
        }

        .info-buttons {
          li {
            margin: 2px;

            .btn-primary {
              padding: 10px 10px;
            }
          }
        }
      }
    }
  }
</style>